import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a07a31d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "training-history-page" }
const _hoisted_2 = { class: "background" }
const _hoisted_3 = { class: "noise grid-wrapper" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "clocks" }
const _hoisted_6 = { class: "controls" }
const _hoisted_7 = { class: "scenario-report" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "uppercase" }, "Training History")
], -1))
const _hoisted_9 = {
  key: 1,
  class: "zero-landing"
}
const _hoisted_10 = { class: "justify-self-center scenario-history" }

import ClockTimerComponent from '@/components/studentPage/ClockTimerComponent.vue';
import ScenarioReportComponent from '../components/trainingHistory/ScenarioReportComponent.vue';
import { ref, onMounted, Ref, shallowRef } from 'vue';
import ScenarioHistoryComponent from '../components/trainingHistory/ScenarioHistoryComponent.vue';
import { useScenarioStore } from '../store/scenarioStore';
import LoginButtonComponent from '@/components/LoginButtonComponent.vue';
import { ScenarioDeserializedThing } from '../ecs/types';
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '../store/globalStore';
import IconComponent from '../components/icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';
import { useRouter } from 'vue-router';
import Routes from '../router/Routes';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingHistoryPage',
  setup(__props) {

const router = useRouter();
const { firebaseUser, currentUser } = storeToRefs(useGlobalStore());
const scenarioStore = useScenarioStore();
const deserializedScenarios: Ref<ScenarioDeserializedThing[]> = ref([]);
const activeScenario = shallowRef<ScenarioDeserializedThing>();

onMounted(async () => {
  deserializedScenarios.value = await scenarioStore.getHistory();
  activeScenario.value = deserializedScenarios.value[0];
});

const handleHomeClicked = () => {
  router.push(Routes.HOME);
};

const onSelectScenario = async (
  selectedScenario: ScenarioDeserializedThing
) => {
  activeScenario.value = selectedScenario;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ClockTimerComponent),
            _createVNode(ClockTimerComponent, { useUTC: false })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(IconComponent, {
              icon: _unref(Icon).HOME,
              onClick: handleHomeClicked,
              class: "cursor-pointer"
            }, null, 8, ["icon"]),
            _createVNode(LoginButtonComponent, {
              class: "text-xs",
              isLoggedIn: _unref(currentUser) !== null,
              isEmailVerified: _unref(firebaseUser)?.emailVerified,
              currentUser: _unref(currentUser)
            }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_unref(activeScenario))
            ? (_openBlock(), _createBlock(ScenarioReportComponent, {
                key: 0,
                class: "self-center w-5/6 bg-white",
                scenario: _unref(activeScenario)
              }, null, 8, ["scenario"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, "No data available"))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_unref(activeScenario))
            ? (_openBlock(), _createBlock(ScenarioHistoryComponent, {
                key: 0,
                scenarios: deserializedScenarios.value,
                selectedItem: _unref(activeScenario),
                onItemClick: onSelectScenario
              }, null, 8, ["scenarios", "selectedItem"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})